const botPatterns = [
  // Search engine bots
  'googlebot',
  'bingbot',
  'yandexbot',
  'duckduckbot',
  'baiduspider',
  'amazonbot',
  'slurp',
  'adsbot',
  // Social media crawlers
  'facebookexternalhit',
  'twitterbot',
  'linkedinbot',
  'whatsapp',
  'telegrambot',
  'slackbot',
  'discordbot',
  // AI/LLM crawlers
  'gptbot',
  'chatgpt',
  'claudebot',
  'anthropic',
  'openai',
  'perplexity',
  'cohere',
  'ai2bot',
  'ccbot',
  'diffbot',
  'bytespider',
  // SEO/monitoring tools
  'semrushbot',
  'ahrefsbot',
  'mj12bot',
  'dotbot',
  'petalbot',
  'seznambot',
  'applebot',
  'lighthouse',
  // Generic patterns (careful — these are broad)
  'crawler',
  'spider',
  'scraper',
  'headless',
  'phantom',
  'selenium',
  'puppeteer',
  'playwright',
];

export function useBotDetection() {
  // x-is-bot is an optional edge hint (not currently set by the Worker); the UA pattern
  // match is the reliable signal on both server and client.
  const requestHeaders = import.meta.server
      ? useRequestHeaders(['x-is-bot', 'user-agent'])
      : {};

  const isBot = computed(() => {
    if(import.meta.server) {
      if(requestHeaders['x-is-bot'] === 'true') {
        return true;
      }
      const ua = (requestHeaders['user-agent'] ?? '').toLowerCase();
      return botPatterns.some(pattern => ua.includes(pattern));
    }

    const ua = navigator.userAgent.toLowerCase();
    return botPatterns.some(pattern => ua.includes(pattern));
  })

  return {
    isBot
  }
}
